import React, { useState, Fragment } from "react";
import { connect } from "react-redux";
import Lottie from "react-lottie";
import loadingData from "./Loading.json";

const Loading = (props) => {
    const [isHide, setHide] = useState(false)

    const renderLoading = () => {    
      window.scrollTo(0, 0)
      const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: loadingData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice",
        },
      };
      setTimeout(()=>{
        setHide(true)
      },2000)
  
      if(!isHide && props.templates.templates){
        return(
          <div className="loadingPage">
            <div>
              <Lottie options={defaultOptions} speed={2} style={{ width:"60%", margin:"auto" }} />
              <div className="text-center" style={{ color:"black", marginTop:"10%" }}>
                  <h6 style={{ fontSize:50 }}>{props.templates.templates.templateProperties.store_name}</h6>
                  <h5>{props.templates.templates.templateProperties.slogan}</h5>
              </div>
            </div>  
          </div>
        )
      }
      else{
          return(
          <div className="loadingPage fadeOut">
            <div>
              <Lottie options={defaultOptions} />
              <div className="text-center">
                  <h6 style={{ fontSize:50, marginTop:50 }}>{props.templates.templates.templateProperties.store_name}</h6>
              </div>
            </div>  
          </div>
        )
      }        
    }

    return (
      <>
        <Fragment>
          {renderLoading()}
        </Fragment>
      </>
    );
}

const mapStateToProps = (state) => {
  return {
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Loading);